<template>
  <slot name="header_close" />
  <div class="which-crm-system-dialog">
    <div class="title" v-html="$t('dialog.which_crm.title')"></div>
    <img class="icon-no-phone" />
    <div class="content">
      <integration-select
        :options="selectedOptions"
        :filter="store.state.dialogParams?.messenger"
        @selectIntegration="whichCrmOpen"
      />
    </div>

    <!-- <button-confirm @click="confirmDialog">{{
      $t("dialog.which_crm.button")
    }}</button-confirm> -->
  </div>
</template>

<script setup>
import { ref } from "vue";
import IntegrationSelect from "@/components/Recurring/IntegrationSelect";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter();

const selectedOptions = ref({ title: false });

const KNOWLEDGE_BASE_URL = "https://help.e-chat.tech/";

const whichCrmOpen = (crmName) => {
  if (crmName === "API") {
    router.push({ name: "API" });
  } else {
    window.open(KNOWLEDGE_BASE_URL, "_blank", "noopener");
  }
  store.commit("closeDialog");
};
</script>

<style lang="scss" scoped>
.which-crm-system-dialog {
  box-sizing: border-box;
  padding: 20px 28px 42px;
  max-width: 620px;
  margin: 0 auto;
  border-radius: 7px;
  background-color: white;

  text-align: center;

  @media screen and (max-width: 640px) {
    max-width: 100%;
  }
}

.title {
  text-align: center;

  font-family: Gilroy;
  font-size: 20px;
  font-weight: 500;
  padding: 0 30px;
  text-transform: uppercase;

  color: var(--text-color);
}

.content {
  margin-top: 25px;
}
</style>
